
import React from 'react';

const SchoolIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M12 2L1 7.5V13h2v-4l9 5 9-5v4h2V7.5L12 2zm0 11.5L4 9l8-4.5 8 4.5-8 4.5zM4 14v5h16v-5H4z" />
  </svg>
);

export default SchoolIcon;
